export const template = `
  <div class='wrapper'>
    <v-btn @click="onClick">
      点我
    </v-btn>
    <v-btn @click="onQuery">
      测试请求
    </v-btn>
  </div>`


export const js = `function generate() {
  return {
    name: 'customCode',
    data(){
      return {
        serviceMethods: {
          query:null
        }
      }
    },
    methods: {
      onClick() {
        const cookie = window.parent.document.cookie
        this.$message.info(\`消息提示: cookie = \${cookie}\`)
      },
      async onQuery(){
        let service=this.$createService("dynamic_parse_page", "5cd7e150d10861024870c30e", "query");
        let res = await service.invokeAsyn();
        console.log(res);
      }
    },
  };
}`

export const css = `.wrapper {
  margin: 10px;
  padding: 10px;
  border: 1px solid #ccc;
}
`